(function () {
    'use strict';

    function main() {

        var searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        var criteria;

        var searchResultsController = {
            init: function () {
                criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                searchResultsController.initPagedResults();
                searchResultsPage.find('[data-phone-summary]').dotdotdot({
                    watch: 'window',
                    height: 40
                });

           
                // TODO: Try reducing cyclomatic complexity and enable the eslint rule
                // eslint-disable-next-line complexity
                searchResultsPage.find('[data-widen-result]').off('click').click(function (e) {
                    WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                    e.preventDefault();
                    var id = wo$(this).data('widen-result');
                    var removeAll = id === 'remove-all';
                    if (id === 'data' || removeAll) {
                        criteria.minData = null;
                    }
                    if (id === 'brands' || removeAll) {
                        criteria.brands = [];
                    }
                    if (id === 'phones' || removeAll) {
                        criteria.models = [];
                    }
                    if (id === 'os' || removeAll) {
                        criteria.operatingSystems = [];
                    }
                    if (id === 'suppliers' || removeAll) {
                        criteria.suppliers = [];
                    }
                    if (id === 'networks' || removeAll) {
                        criteria.networks = [];
                    }
                    if (id === 'screen' || removeAll) {
                        criteria.minScreen = null;
                        criteria.maxScreen = null;
                    }
                    if (id === 'camera' || removeAll) {
                        criteria.camera = null;
                    }
                    if (id === 'spend' || removeAll) {
                        criteria.minSpend = null;
                        criteria.maxSpend = null;
                    }
                    if (id === 'upfront' || removeAll) {
                        criteria.maxUpfront = null;
                    }
                    if (id === 'priceTypes' || removeAll) {
                        criteria.priceTypes = [];
                    }
                    if (id === 'released' || removeAll) {
                        criteria.released = null;
                    }
                    if (id === 'keyword' || removeAll) {
                        criteria.search = null;
                    }
                    if (id === 'planType' || removeAll) {
                        criteria.planType = null;
                    }
                    if (id === '5g' || removeAll) {
                        criteria.show5G = null;
                    }
                    if (id === 'esim' || removeAll) {
                        criteria.showESim = null;
                    }
                    if (id === 'editorspicks' || removeAll) {
                        criteria.showEditorsPicksOnly = null;
                    }
                    if (id === 'bluetick' || removeAll) {
                        criteria.showTelstraBlueTickOnly = null;
                    }
                    if (id === 'optuspick' || removeAll) {
                        criteria.optusRegionalPickOnly = null;
                    }
                    if (id === 'singlePhonePerBrand' || removeAll) {
                        criteria.singlePhonePerBrand = null;
                    }
                    if (id === 'sort' || removeAll) {
                        criteria.sortExpression = null;
                        criteria.sortAscending = true;
                    }
                    WhistleOut.scrollTo(0);
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Widen', criteria: criteria });
                });
            },

            toggleLoadMoreButtonVisbility: function () {
                var current = searchResultsPage.find('[data-current]:last').data('current');
                var total = searchResultsPage.find('[data-results-count]:last').data('results-count');
                if (current >= total) {
                    searchResultsPage.find('#load-more').hide();
                } else {
                    searchResultsPage.find('#load-more').show();
                }
            },

            initPagedResults: function () {
                searchResultsController.toggleLoadMoreButtonVisbility();

                searchResultsPage.find('#load-more button').off('click').click(function () {
                    var current = searchResultsPage.find('[data-current]:last').data('current');
                    var queryString = WhistleOut.MobilePhones.generatePhonesQueryString(criteria);
                    searchResultsPage.find('#load-more button .fa-spinner').show();
                    wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                    wo$.ajax({
                        url: criteria.pagedResultsAjaxUrl + '?' + queryString + '&current=' + current,
                        type: 'GET',
                        success: function (result) {
                            var $results = wo$('div.results-list');
                            $results.append(result);
                            $results.find('[data-phone-summary]').dotdotdot({
                                watch: 'window',
                                height: 40
                            });
                            //searchResultsController.initGallery();
                            WhistleOut.applyPopover($results);
                            searchResultsPage.find('#load-more button .fa-spinner').hide();
                            wo$('[data-enable-when-ready]').removeAttr('disabled');
                            searchResultsController.toggleLoadMoreButtonVisbility();
                        },
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        error: function () {
                        }
                    });
                });
            }

        };

        searchResultsController.init();
        WhistleOut.notifications.add(function (notification) {
            if (notification === 'SearchResultsRendered') {
                searchResultsController.init();
            }
        });
    };

    WhistleOut.initModule(import.meta.url, main);

}());